// extracted by mini-css-extract-plugin
export default {"grid":"grid__1Lwr0"};